import { ClientInferRequest, ClientInferResponseBody } from "@ts-rest/core";

import { contract } from "#app/http/api";
import { api } from "#app/http/api";
import { ApiError } from "#shared/infra/apiError";

export type CreateMaterialsVolumetricPrice = ClientInferResponseBody<
  typeof contract.materials.createMaterialsVolumetricPrice
>;

export type CreateMaterialsVolumetricPriceDto = ClientInferRequest<
  typeof contract.materials.createMaterialsVolumetricPrice
>["body"];

export const createMaterialsVolumetricPrice = async (
  body: CreateMaterialsVolumetricPriceDto,
): Promise<CreateMaterialsVolumetricPrice> => {
  const response = await api.materials.createMaterialsVolumetricPrice.mutation({
    body,
  });

  if (response.status === 200) {
    return response.body;
  }

  throw new ApiError("Failed to create MaterialsVolumetricPrice", response.status, response.body);
};
